import React from "react";
import logo from "../../../../assets/Images/logo-icon.png";
import logoBig from "../../../../assets/Images/au-logo-long.png";
import "./logo.css";


export default function Logo({sidebarOpen}) {

    return (
        <div className="logo">
            {sidebarOpen ? <img src={logoBig} alt="AutomMate Logo" style={{width: "75%"}}/> :
                <img src={logo} alt="AutomMate Logo"/>}
            {/* <ChevronLeft className={classes.svgIcon} /> */}
        </div>
    )
}
